class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );

        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );

        const closeButton = this.querySelector('button[type="button"]');
        if (closeButton) {
            closeButton.addEventListener('click', this.close.bind(this));
        }

        this.summaryToggle.setAttribute('role', 'button');
        this.summaryToggle.setAttribute('aria-expanded', 'false');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();

        event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target)) this.close(false);
    }

    open(event) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        this.summaryToggle.setAttribute('aria-expanded', 'true');
        document.body.addEventListener('click', this.onBodyClickEvent);

        const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
        const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
        if (focusContainer) {
            trapFocus(focusContainer, searchInput || focusContainer);
        }
        if (searchInput) {
            window.requestAnimationFrame(() => searchInput.focus({ preventScroll: true }));
        }

        var target = $(searchInput?.closest('.quickSearch')),
            quickSearch = target.closest('.quickSearch');
    }

    close(focusToggle = true) {
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.detailsContainer.removeAttribute('open');
        this.summaryToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('open_search_menu');
        document.body.removeEventListener('click', this.onBodyClickEvent);
    }
}

customElements.define('details-modal', DetailsModal);
